export const initialState = {
  data: [],
  loading: false,
  error: null,
  message: "",
  status: null,
  apiError: false,
  apiSuccess: false,
  next: false,
};
